export {default as TabList} from './TabList';
export {default as Tab} from './Tab';



// WEBPACK FOOTER //
// ./src/components/Tabs/index.ts